import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, List } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";

const Recruit = () => {
  return(
    <>
      <Head slug="recruit">
        <Space size={['54px 0 104px', '32px 0 72px']}>
          <Texts slug={`merit/top-title`} class={''} />
        </Space>
      </Head>
      <Space size={['80px', '64px']}></Space>
      <Media src={`title/merit`} alt={'MERIT'} class={`p-img__title--merit p-img__title`} />
      <Space size={['24px 0 0', '24px 0 0']}>
        <Texts slug={`merit/title`} class={'c-text--center'} />
      </Space>

      <Space size={['92px 0 200px', '72px 0 120px']}>
        <div className="l-row c-grid__list--merit">
          <List Item={Item} length={4}></List>
        </div>
      </Space>
    </>
  )
};
export default Recruit;

const Item = (props) => {
  return(
    <>
      <div className="p-box__items--merit">
        <div className="p-box__items--merit__number">
          <Texts slug={`merit/number${props.index}`} class={'c-text--en c-text--big'} />
        </div>
        <div className="l-row p-box__items--merit__inner" data-state="middle">
          <Texts slug={`merit/title${props.index}`} class={''} />
          <Texts slug={`merit/body${props.index}`} class={''} />
        </div>
      </div>
    </>
  )
}
